export default urlResolver => (nextState, replace, callback) => {
  replace(urlResolver.getPayoutMethodsUrl());
  callback();
};
